// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TVPAGE .main-content.site-wrapper{background-color:#f8f8f8}`, "",{"version":3,"sources":["webpack://./sass/home.scss"],"names":[],"mappings":"AACA,mCACE,wBAAA","sourcesContent":["@import \"variables.json\";\n.main-content.site-wrapper{\r\n  background-color: #f8f8f8;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
